module.exports = __webpack_public_path__ + "static/media/hr.88f38f33.svg";